module.exports = __webpack_public_path__ + "washburn-share-logo (1).jpg?c8fa726f53d32d12cda3d2d12ec43025";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/washburn-share-logo (1).jpg
// module id = 134
// module chunks = 0